// async
export const SET_TASKS_INCOMPLETE_COUNT = 'SET_TASKS_INCOMPLETE_COUNT';

// non-async